import * as Array from 'effect/Array';
import {pipe} from 'effect/Function';
import React from 'react';
import {cn, InlineSvg} from '~/library/ui-kit';
import * as css from './DashboardActionGroup.css';

export function DashboardActionGroup(props: {
    className?: string;
    actions: {onClick: () => void; label: string; icon: string}[];
}) {
    return (
        <section className={cn(css.groupContainer, props.className)}>
            {pipe(
                props.actions.map((action, i) => (
                    <button key={i} type='button' onClick={action.onClick} className={css.actionButton}>
                        <InlineSvg className='size-5' src={action.icon} />
                        <span>{action.label}</span>
                    </button>
                )),
                Array.intersperse(<hr className={css.separator} />),
                Array.map((el, i) => <el.type key={i} {...el.props} />)
            )}
        </section>
    );
}
